import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';
import {PatientService} from '../ClientInfo/patient.service';


@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

    constructor(private authService: AuthService,
                private router: Router,
                private patientService: PatientService) {
    }

    /**
     * checks if specific sites can be accessed
     */
    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        this.patientService.patientID = route.queryParamMap.get('id');
        console.log(this.patientService.patientID);
        if (this.authService.isLoggedIn()) {
            return true;
        }
        this.router.navigate(['/auth']);
        return false;
    }
}
